if (!customElements.get('full-width-element')) {
  customElements.define('full-width-element', class FullWidthElement extends HTMLElement {
    connectedCallback() {
      this.lastScrollbarWidth = null;
      this.setScrollbarWidth();

      this.onResize = () => {
        window.requestAnimationFrame(() => {
          this.setScrollbarWidth();
        });
      };

      window.addEventListener('resize', this.onResize, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
    }

    setScrollbarWidth() {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

      if (scrollbarWidth === this.lastScrollbarWidth) return;

      this.lastScrollbarWidth = scrollbarWidth;
      document.body.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
    }
  });
}